import React, { useEffect, useState } from 'react'
import { ICompanyMast } from '../../models/CompanyMast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Dialog } from 'primereact/dialog';
import { JVInput } from '../../shared/JVInput';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { baseUrl, Fetch } from '../../shared/Fetch';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { JVDropdown } from '../../shared/JVDropdown';
import { ICompanyDocDropdown } from '../../models/IDropdown';


interface IProps {
    singleData: ICompanyMast;
    open?: boolean;
    hideDialog: () => void;
    toast: any;
}


export interface ICompanyDocument {
    document_ID?: number;
    document_Name?: number;
    // designation?: string;
    company_ID?: number;
    document_Path?: string;
}

const emptyFormData: ICompanyDocument = {
    // document_Name: '',
    // document_Path:''
}

const schema = yup.object().shape({
    document_Name: yup.number().nullable(),
});
export const CompanyDocumentUpload = (props: IProps) => {
    const [loading, setLoading] = useState<Boolean>(false);
    const [documents, setDocuments] = useState<File | null>(null);
    const [tableData, setTableData] = useState<ICompanyDocument[]>([]);
    const [editingData, setEditingData] = useState<ICompanyDocument | null>(null);
    const [companyDocument, setCompanyDocument] = useState<ICompanyDocDropdown[]>();
    const [documentHistory, setDocumentHistory] = useState({ document_ID: 0, open: false } as { document_ID: number | undefined, open: boolean });
    const [historyData, setHistoryData] = useState({ tableData: [], loading: false } as { tableData: Array<ICompanyDocument>, loading: boolean });


    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<ICompanyDocument>({
        resolver: yupResolver(schema),
        defaultValues: {}
    });

    useEffect(() => {
        if (props.singleData.company_ID) {
            setValue('company_ID', props.singleData.company_ID);
        }
    }, [props.singleData, setValue]);


    const onSubmit = async (data: any, event: any) => {
        data.company_ID = props.singleData.company_ID
        if (data.document_Name == null) {
            props.toast.current.show({ severity: 'error', detail: "Please select the Document type.", life: 3000 });
            return;
        }
        setLoading(true);
        if (!documents) {
            props.toast.current.show({ severity: 'error', detail: "Please upload the Document.", life: 3000 });
            return;
        }

        const formData = new FormData();
        if (documents) {
            formData.append('document', documents);
        }
        formData.append('data', JSON.stringify(data));

        const method = editingData?.document_ID ? "PUT" : "POST";
        const message = editingData?.document_ID ? "Updated Successfully" : "Added Successfully";


        try {
            const response = await fetch(`${baseUrl}Company_Mast/uploadCompanyDocument`, {
                method: method,
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token
                        }`
                },
                body: formData
            });

            if (response.ok) {
                props.toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                reset(emptyFormData);
                setDocuments(null);
                LoadTableData();
                setEditingData(null);


            } else {
                const errorText = await response.text();
                console.error('Error:', errorText);
                props.toast.current.show({ severity: 'error', detail: errorText, life: 3000 });
                reset(emptyFormData);
                setDocuments(null);
                LoadTableData();
                setEditingData(null);

            }
        } catch (error) {
            props.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save data', life: 3000 });
        }
        setLoading(false)
        setDocuments(null);
        setEditingData(null);
    }

    const LoadTableData = async () => {
        setLoading(true);
        const response = await Fetch("Company_Mast/getDocumentList", "GET", null, `company_ID=${props.singleData.company_ID}`, props.toast);
        if (response) {
            const data = await response.json();
            console.log(data)
            setTableData(data);
        } else {
            props.toast.current.show({ severity: 'error', detail: "Failed To Load Designation List", life: 3000 });
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open === true) {
            LoadTableData();
            loadDocumnetList();
        }
    }, [props.open]);

    const uploadCompanyDocument = (event: any) => {
        const file = event.files[0];
        setDocuments(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Document Selecetd", life: 3000 });
        event.options.clear();

    }

    const Action = (rowData: ICompanyDocument) => {
        return (

            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary p-button-text" onClick={() => editSignatory(rowData)} />
                <Button icon="pi pi-clock" className="p-button-rounded p-button-secondary p-button-text" onClick={() => { getDocumentHistory(rowData); setDocumentHistory({ document_ID: rowData.document_ID, open: true }) }} />
            </>
        );
    };

    const getDocumentHistory = async (data: ICompanyDocument) => {
        setHistoryData({ tableData: historyData.tableData, loading: true });

        const response = await Fetch("Company_Mast/getDocumentHistory", "GET", null, `document_ID=${data.document_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setHistoryData({ tableData: data, loading: false });
        } else setHistoryData({ tableData: historyData.tableData, loading: false });

    }

    const editSignatory = (rowData: ICompanyDocument) => {
        setEditingData(rowData);
    };

    useEffect(() => {
        if (editingData != null) {
            setValue('document_Name', editingData.document_Name);
            // setValue('designation', editingData.designation);
            setValue('company_ID', editingData.company_ID);
            setValue('document_ID', editingData.document_ID)
        } else {
            reset(emptyFormData);
        }
    }, [editingData, setValue, reset]);

    const documentsIcon = (rowData: ICompanyDocument) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => editSignatory(rowData)} />
                <Button icon="pi pi-arrow-down" className="p-button-rounded p-button-text" onClick={() => documentsDownload(rowData)} tooltip="Download documents" />
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" onClick={() => documentsView(rowData)} tooltip="View documents" />
                <Button icon="pi pi-clock" className="p-button-rounded p-button-text" onClick={() => { getDocumentHistory(rowData); setDocumentHistory({ document_ID: rowData.document_ID, open: true }) }} />
            </>
        );
    };

    const documentsDownload = async (rowData: ICompanyDocument) => {
        const Id = rowData.document_ID;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`
            },
        };

        try {
            const response = await fetch(`${baseUrl}Company_Mast/getdownloadDocumnet?Id=${Id}`, params);
            if (response.status === 200) {
                const contentType = response.headers.get("Content-Type");
                const blob = await response.blob();

                const fileExtension = contentType?.includes("image/png")
                    ? ".png"
                    : contentType?.includes("image/jpeg")
                        ? ".jpeg"
                        : contentType?.includes("application/pdf")
                            ? ".pdf"
                            : contentType?.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                                ? ".xlsx"
                                : "";

                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");

                a.download = `${rowData.document_Name}${fileExtension}`;
                a.href = href;
                a.click();
                window.URL.revokeObjectURL(href);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };


    const downloadHistoryDocument = async (rowData: any) => {
        //const documentId = rowData.document_ID;
        const history_ID = rowData.history_ID;

        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`
            },
        };

        try {
            const response = await fetch(`${baseUrl}Company_Mast/downloadCompanyDocumentHistory?history_ID=${history_ID}`, params);

            if (response.status === 200) {
                const contentType = response.headers.get("Content-Type");
                const blob = await response.blob();

                const fileExtension = contentType?.includes("image/png")
                    ? ".png"
                    : contentType?.includes("image/jpeg")
                        ? ".jpeg"
                        : contentType?.includes("application/pdf")
                            ? ".pdf"
                            : contentType?.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                                ? ".xlsx"
                                : "";

                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");

                a.download = `${rowData.document_Name}${fileExtension}`;
                a.href = href;
                a.click();
                window.URL.revokeObjectURL(href);
            } else if (response.status === 400 || response.status === 404) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };


    const documentsView = async (rowData: ICompanyDocument) => {
        const Id = rowData.document_ID;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`,
            },
        };

        try {
            const response = await fetch(`${baseUrl}Company_Mast/viewDocument?Id=${Id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();

                // Generate a URL for the blob
                const href = window.URL.createObjectURL(blob);

                // Open the file in a new tab
                window.open(href, '_blank');

                // Revoke the URL after some time to free up resources
                setTimeout(() => {
                    window.URL.revokeObjectURL(href);
                }, 100);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };

    const documentsHistoryView = async (rowData: any) => {
        const Id = rowData.history_ID;
        const params = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`,
            },
        };

        try {
            const response = await fetch(`${baseUrl}Company_Mast/viewCompanyDocumentHistory?history_ID=${Id}`, params);
            if (response.status === 200) {
                const blob = await response.blob();

                // Generate a URL for the blob
                const href = window.URL.createObjectURL(blob);

                // Open the file in a new tab
                window.open(href, '_blank');

                // Revoke the URL after some time to free up resources
                setTimeout(() => {
                    window.URL.revokeObjectURL(href);
                }, 100);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong', life: 3000 });
        }
    };


    const loadDocumnetList = async () => {
        const response = await Fetch("Dropdown/getCompanyDocument", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyDocDropdown> = await response.json();
            setCompanyDocument(data);
        }
    }
    const header = () => {
        return <span> Add/Edit Company Document- <span style={{ color: "red" }}>({props.singleData.company_Name})</span> </span>
    }

    const onHide = () => {
        props.hideDialog();
        reset(emptyFormData);
        setDocuments(null)
        setEditingData(null);

    };

    const onHideHistory = () => {
        setDocumentHistory({ open: false, document_ID: 0 })
    }
    const onClear = () => {
        //props.hideDialog();
        reset(emptyFormData);
        setDocuments(null)
        setEditingData(null);

    };

    const Action1 = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-arrow-down" className="p-button-rounded p-button-text" onClick={() => downloadHistoryDocument(rowData)} tooltip="Download documents" />
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" onClick={() => documentsHistoryView(rowData)} tooltip="View documents" />
            </>
        );
    };


    return (
        <>
            <Dialog visible={props.open} style={{ width: '50vw' }} header={header} modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className='p-fluid formgrid grid'>
                    <JVDropdown disabled={editingData != null} column={3} label="Document Name" required control={control} name="document_Name" optionLabel="document_Name"
                        optionValue="document_ID" options={companyDocument} placeholder="Select " />
                    <div className='mt-4 ml-3'>
                        <FileUpload mode="basic" name="document_Path" chooseLabel="Upload Document" auto customUpload uploadHandler={uploadCompanyDocument}  ></FileUpload>
                    </div>
                    <div className="col-12 md:col-12 flex gap-4 justify-content-start">
                        <Button style={{ width: '100px' }} label={editingData != null ? "UPDATE" : "SAVE"} type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" className="p-button-outlined surface-200		"></Button>
                    </div>
                </form>
                <div className=''>
                    <DataTable style={{ fontSize: "15px", marginBottom: "10px" }} value={tableData} lazy dataKey="id" size="small"
                        tableStyle={{ minWidth: "50rem", maxHeight: "3rem" }}
                        showGridlines
                    >
                        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                        <Column field="document_Names" header="Document Name" />
                        <Column field='document_Path' header="Action" body={documentsIcon} />
                        {/* <Column header="Action" body={Action} /> */}
                    </DataTable>
                </div>
            </Dialog>
            <Dialog visible={documentHistory.open} style={{ width: '40vw' }} header="History of document" modal className="p-fluid" onHide={onHideHistory} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={historyData.tableData}
                // loading={historyRepostData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    {/* <Column field="req_ID" header="Req.ID" sortable body={req_ID} /> */}
                    <Column field="document_Name" sortable header="Document Name" />
                    <Column header="Action" body={Action1} />

                </DataTable>

            </Dialog>
        </>
    )
}
